import { useAppDispatch } from '~/redux/hooks';
import { setLoggingOut } from '~/redux/modules/authentication';
import { clearBadge } from '~/redux/modules/badge';
import { clearFlashMessage } from '~/redux/modules/flashNotification';
import { clearGroupInfo } from '~/redux/modules/groupInfo';
import { clearMessages } from '~/redux/modules/message';
import { clearProfile } from '~/redux/modules/profile';
import useGroupInfo from './useGroupInfo';
import { clearCategories } from '~/redux/modules/category';
import { clearQuestionAnswers } from '~/redux/modules/questionAnswers';
import { clearProviders } from '~/redux/modules/providers';
import { clearWelfareRoles } from '~/redux/modules/welfareRoles';

const useClearStates = () => {
    const dispatch = useAppDispatch();
    const { onClearGroups } = useGroupInfo();

    const onClear = () => {
        dispatch(setLoggingOut());
        dispatch(clearFlashMessage());
        dispatch(clearBadge());
        dispatch(clearGroupInfo());
        dispatch(clearMessages());
        dispatch(clearProfile());
        dispatch(clearCategories());
        dispatch(clearQuestionAnswers());
        dispatch(clearProviders());
        dispatch(clearWelfareRoles());

        onClearGroups();
    };

    return onClear;
};

export default useClearStates;
